import { Col, Row } from "antd";
import React from "react";
import { ProductList } from "./ProductList";
import { ProductSearch } from "./ProductSearch";

export const ProductMenu = () => {
  return (
    <div>
      <ProductSearch />
    </div>
  );
};
